import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import { useTheme } from "@mui/material/styles";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { Box, FormControl, FormHelperText, GlobalStyles } from "@mui/material";

const RHFPhoneInput = ({
  name,
  isOverCard = false,
  hasError = false,
  hideLabel = false,
  errors = [],
  ...other
}) => {
  const theme = useTheme();
  const [isFocused, setIsFocused] = useState(false); // New state variable
  const phoneInputRef = useRef(null);

  const classes = {
    dropdownStyle: {
      backgroundColor: theme.palette.background.default,
    },
    inputStyle: {
      // Add your theme styles here
      backgroundColor: "rgba(255, 0, 0, 0)",
      borderColor:
        hasError === false
          ? theme.palette.error.main
          : theme.palette.text.superDisabled,
      color: theme.palette.text.primary,
      borderRadius: theme.shape.borderRadius,
      width: "100%",

      // ...more styles
    },
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        phoneInputRef.current &&
        !phoneInputRef.current.contains(event.target)
      ) {
        if (isFocused === false) {
          setIsFocused(false);
        }
      } else {
        setIsFocused(true);
      }
    }

    // Attach the listeners to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Remove the listeners
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [phoneInputRef]);

  const { control } = useFormContext();

  const helperText = errors[name]?.message || "";

  return (
    <>
      {" "}
      <GlobalStyles
        styles={{
          ".react-tel-input .special-label": hideLabel ? {
              display: "none !important",
          } : {
            backgroundColor: `${isOverCard
              ? theme.palette.background.paper
              : theme.palette.background.default
              } !important`,
            color: `${hasError === false
              ? isFocused
                ? theme.palette.text.primary
                : theme.palette.text.disabled
              : theme.palette.error.main
              }`,
          },
          ".react-tel-input .form-control": {
            boxShadow: `0px 0px 0px 0px ${isFocused
              ? theme.palette.text.primary
              : theme.palette.text.superDisabled
              } !important`,
            borderColor: `${hasError === false
              ? isFocused
                ? theme.palette.text.primary
                : theme.palette.text.superDisabled
              : theme.palette.error.main
              } !important`,
            width: "100% !important",
          },
          ".react-tel-input .form-control:hover": {
            boxShadow: `0px 0px 0px 0px ${theme.palette.text.primary} !important`,
            borderColor: `${theme.palette.text.primary} !important`,
            width: "100% !important",
          },
          ".react-tel-input .country-list .country.highlight": {
            backgroundColor: `${theme.palette.text.disabled} !important`,
          },
          ".react-tel-input .country-list .country:hover": {
            backgroundColor: `${theme.palette.text.disabled} !important`,
          },
          ".react-tel-input .country-list .country .dial-code": {
            color: `${theme.palette.text.primary} !important`,
          },
        }}
      />
      <FormControl error={Boolean(errors[name])} variant="outlined" sx={{ width: "100%" }}>
        <Box ref={phoneInputRef}>
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <PhoneInput
                {...other}
                inputProps={{
                  name: name,
                  autoComplete: "off",
                  ref: field.ref,
                }}
                inputStyle={classes.inputStyle}
                dropdownStyle={classes.dropdownStyle}
                country="ro"
                onlyCountries={[
                  "ro",
                  "gb",
                  "de",
                  "fr",
                  "us",
                  "be",
                  "bg",
                  "cz",
                  "dk",
                  "ee",
                  "ie",
                  "gr",
                  "es",
                  "hr",
                  "it",
                  "cy",
                  "lu",
                  "hu",
                  "mt",
                  "nl",
                  "at",
                  "pl",
                  "si",
                  "pt",
                  "sk",
                  "fi",
                ]}
                value={field.value || "+40"}
                countryCodeEditable={false}
                onChange={(value, country, e, formattedValue) => {
                  let val = value;
                  if (value.startsWith(country.dialCode + "0")) {
                    val = country.dialCode + val.slice(country.dialCode.length + 1);
                  }
                  field.onChange(val);

                  if (other.onChange) {
                    other.onChange(val, country, e, formattedValue);
                  }
                }}
                onBlur={(e) => {
                  field.onBlur();
                  if (other.onBlur) {
                    other.onBlur(e);
                  }
                }}
              />
            )}
          />
        </Box>
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    </>
  );
};

RHFPhoneInput.propTypes = {
  name: PropTypes.string.isRequired,
};

export default RHFPhoneInput;
